import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type ToggleActivePayload = {
  id: EntityId
}

export const toggleRunStatus = createAsyncThunk('runs/toggleRunStatus', async ({ id }: ToggleActivePayload) => {
  const results = await OLMSApiService.post<number>('/run/toggleActive', [id])

  return results
})